const logs = {
    page_title: 'Log di Audit',
    title: 'Log di Audit',
    subtitle: 'Visualizza i dati di registro degli eventi di autenticazione effettuati dai tuoi utenti',
    event: 'Evento',
    user: 'Utente',
    application: 'Applicazione',
    time: 'Tempo',
    filter_by: 'Filtra per',
    last_1_hour: 'Ultima ora',
    last_24_hours: 'Ultime 24 ore',
    last_7_days: 'Ultimi 7 giorni',
    last_30_days: 'Ultimi 30 giorni',
    custom_range: 'Intervallo personalizzato',
    from: 'Dal',
    to: 'Al',
};
export default Object.freeze(logs);
